import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    colorMenuLabel: string;
    defaultColor: string;
    disclaimer: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the color submenu button */
            colorMenuLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderColorMenuItems.colorMenuLabel?c=355hvld4oddso", defaultMessage: "Folder Color" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the default (no color) option */
            defaultColor: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderColorMenuItems.defaultColor?c=k20bb1a2onqs", defaultMessage: "Default" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Disclaimer text shown at the bottom of the color submenu */
            disclaimer: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderColorMenuItems.disclaimer?c=p10soae5wgvn", defaultMessage: "This feature is in early development and may change or be discontinued." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
